export const FORMS_MACHINE_ID = 'productFieldsManagerMachine';

export const productFormsMachineStates = {
  getInitialConfigState: 'getInitialConfigState',
  getInitialConfigFailureState: 'getInitialConfigFailureState',
  loggingOutUserState: 'loggingOutUserState',
  notLoggedInUserState: 'notLoggedInUserState',
  optVerificationState: 'optVerificationState',
  newUserLoginState: 'newUserLoginState',
  phoneNumberNotVerifiedState: 'phoneNumberNotVerifiedState',
  getClientAuthCodeState: 'getClientAuthCodeState',
  formSubmitState: 'formSubmitState',
  formEditingState: 'formEditingState',
  getClientAuthenticationDetailsState: 'getClientAuthenticationDetailsState',
  getProfileDetailsState: 'getProfileDetailsState',
  updateProfileState: 'updateProfileState',
  createFreeOrderState: 'createFreeOrderState',
  getOrderStatusState: 'getOrderStatusState',
  getReferralCodesState: 'getReferralCodesState',
  trackReferralAttemptState: 'trackReferralAttemptState',
  updateUserExtraInfoState: 'updateUserExtraInfoState',
  sendBackendTrackEventSegmentApiState: 'sendBackendTrackEventSegmentApiState',
  initializeAuthMachineState: 'initializeAuthMachineState'
};

export const productFormsMachineEvents = {
  getInitialConfigRetryEvent: 'GET_INITIAL_CONFIG_RETRY_EVENT',
  goToOtpVerificationStep: 'GO_TO_OTP_VERIFICATION_STEP',
  onSuccessOtpVerification: 'ON_SUCCESS_OTP_VERIFICATION',
  goToNotLoggedInUserState: 'GO_TO_NOT_LOGGED_IN_USER_STATE',
  onSubmitFormClicked: 'ON_SUBMIT_FORM_CLICKED',
  goToPreviousStep: 'GO_TO_PREVIOUS_STEP',
  goToFormEditingState: 'GO_TO_FORM_EDITING_STATE',
  clearErrorMessage: 'CLEAR_ERROR_MESSAGE',
  goToNextStep: 'GO_TO_NEXT_STEP',
  loggingOutUser: 'LOGGING_OUT_USER',
  goToCreateFreeOrderState: 'GO_TO_CREATE_FREE_ORDER_STATE',
  assignConfigEventsToContext: 'ASSIGN_CONFIG_EVENT_TO_CONTEXT',
  goToUpdateProfileDetailsState: 'GO_TO_UPDATE_PROFILE_DETAILS',
  callEventsFromConfig: 'CALL_EVENTS_FROM_CONFIG',
  goToUpdateUserExtraInfoState: 'Go_TO_UPDATE_USER_EXTRA_INFO_STATE',
  doSelfTransition: 'DO_SELF_TRANSITION',

  loggedOutUser: 'LOGGED_OUT_USER',
  setGoToNextSteps: 'SET_GO_TO_NEXT_STEPS',
  onEntryGetOTP: 'ON_ENTRY_GET_OTP',
  onSuccessGetOTP: 'ON_SUCCESS_GET_OTP',
  onErrorGetOTP: 'ON_ERROR_GET_OTP',
  onSuccessGetSignUpOTP: 'ON_SUCCESS_GET_SIGN_UP_OTP',
  doChildMachineSelfTransition: 'DO_CHILD_MACHINE_SELF_TRANSITION',
  sendGAEvent: 'SEND_GA_EVENT',
  sendFrontendSegmentEvent: 'SEND_FRONTEND_SEGMENT_EVENT',
  sendBackendSegmentEvent: 'SEND_BACKEND_SEGMENT_EVENT',
  resetAuthMachine: 'RESET_AUTH_MACHINE',
  clearPrefilledFormData: 'CLEAR_PREFILLED_FORM_DATA',
  resendOtpClicked: 'RESEND_OTP_CLICKED'
};

export const productFormsMachineTags = {
  getInitialConfigLoadingTag: 'getInitialConfigLoadingTag',
  otpApiInitiated: 'otpApiInitiated',
  otpVerifyBtnLoading: 'otpVerifyBtnLoading',
  buttonLoading: 'buttonLoading',
  submitBtnLoading: 'submitBtnLoading',
  formLoading: 'formLoading'
};

export const productFormMachineActions = {
  spawnAuthCoreMachine: 'spawnAuthCoreMachine',
  setNextAndSubmitBtnLoadingToTrue: 'setNextAndSubmitBtnLoadingToTrue',
  setIsOtpButtonLoadingToFalse: 'setIsOtpButtonLoadingToFalse',
  setIsOtpButtonLoadingToTrue: 'setIsOtpButtonLoadingToTrue',
  setNextAndSubmitBtnLoadingToFalse: 'setNextAndSubmitBtnLoadingToFalse',
  updateIsOtpSentToUserInContext: 'updateIsOtpSentToUserInContext',
  sendGetOtpCustomEventToDataLayer: 'sendGetOtpCustomEventToDataLayer',
  updateIsNewUserInContextToFalse: 'updateIsNewUserInContextToFalse',
  updateIsNewUserInContextToTrue: 'updateIsNewUserInContextToTrue',
  callEventsFromConfig: 'callEventsFromConfig',
  clearErrorMessageFromContext: 'clearErrorMessageFromContext',
  resetOtp: 'resetOtp',
  assignErrorMessageToContext: 'assignErrorMessageToContext',
  assignChildSelfTransitionToConfigEvents:
    'assignChildSelfTransitionToConfigEvents',
  doChildMachineSelfTransition: 'doChildMachineSelfTransition',
  sendGAEventToDataLayer: 'sendGAEventToDataLayer',
  sendFrontendSegmentEvent: 'sendFrontendSegmentEvent',
  setLoginAccessAndRefreshToken: 'setLoginAccessAndRefreshToken',
  clearPrefilledFormDataAction: 'clearPrefilledFormDataAction',
  sendResendOtpEventToDataLayer: 'sendResendOtpEventToDataLayer',
  onErrorTrackReferralAttemptLogEntry: 'onErrorTrackReferralAttemptLogEntry'
};

export const productFormsMachineServices = {
  callBackendSegmentApi: 'callBackendSegmentApi'
};
